/**
 * TanStack Router: /team-courses
 *
 * This route file was auto-generated by the route generation script.
 * Component: TeamCoursesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import TeamCoursesPage from '@/app/team-courses/page'

/**
 * Route: /team-courses
 * Layout: _auth (authenticated)
 * Component: TeamCoursesPage
 */
export const Route = createFileRoute('/_auth/team-courses')({
  component: TeamCoursesPage,
})
